var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import AsyncSelect from "react-select/async";
import { InputAdornment, Box, makeStyles, } from "@material-ui/core";
import { components } from "react-select";
import { useClickOutside } from "ftl-dashboards-core";
import { FTLTextField } from "../FTLTextField";
import { InfiniteLoader } from "./InfiniteLoader";
import { CustomValueContainer } from "./CustomValueContainer";
import { SearchIcon, ClearIcon, ChevronIcon } from "../icons";
import { FTLDots } from "../FTLDots";
import { FTLLabel } from "../FTLLabel";
import { FTLIconButton } from "../FTLIconButton";
import { defaultSelectStyles } from ".";
import { useCallback, useRef, useState } from "react";
import { FTLTypography } from "../FTLTypography";
import { FTLCheckbox } from "../FTLCheckbox";
import { FTLDropdownMenu } from "../FTLDropdownMenu/FTLDropdownMenu";
import { typography } from "../../shared/theme";
export function FTLSelectAsync(_a) {
    var { label, placeholder = "Поиск", searchPlaceholder = "Поиск", noOptionsMessage = () => "Нет данных", itemSize = 32, records = 4, defaultValue, name, loadData, value, isClearable, isMulti, isDisabled, isSearchInList = true, isSearchable = true, isInfinite = true, withCheckboxes = false, required, isError, onChange, onClick, showLoader = true, size = "default", width = "default", menuWidth, meta, BoxProps, popperPlacement = "bottom-start" } = _a, otherProps = __rest(_a, ["label", "placeholder", "searchPlaceholder", "noOptionsMessage", "itemSize", "records", "defaultValue", "name", "loadData", "value", "isClearable", "isMulti", "isDisabled", "isSearchInList", "isSearchable", "isInfinite", "withCheckboxes", "required", "isError", "onChange", "onClick", "showLoader", "size", "width", "menuWidth", "meta", "BoxProps", "popperPlacement"]);
    const [selectedOptions, setSelectedOptions] = useState(value ? (value instanceof Array ? value : [value]) : null);
    const isSelected = useCallback((data) => {
        if (selectedOptions)
            return selectedOptions.some((item, i) => {
                if (item.value === data.value) {
                    return true;
                }
                return false;
            });
        return false;
    }, [selectedOptions]);
    const containerRef = useRef(null);
    const popperRef = useRef(null);
    const controlRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleClickOutside = useCallback((e) => {
        if (controlRef.current !== e.target)
            setIsMenuOpen(false);
    }, []);
    useClickOutside(popperRef, handleClickOutside);
    return (React.createElement(Box, Object.assign({ width: "100%", maxWidth: size === "small" ? 160 : "auto" }, BoxProps),
        label && React.createElement(FTLLabel, { label: label, required: required }),
        React.createElement("div", { ref: containerRef, onClick: onClick },
            React.createElement(AsyncSelect, Object.assign({ loadOptions: () => { }, placeholder: placeholder, styles: defaultSelectStyles(size, isError, isMulti, isMenuOpen, isDisabled, withCheckboxes), onChange: (value, meta) => {
                    if (isMulti) {
                        setSelectedOptions(value || null);
                    }
                    onChange &&
                        onChange(value, meta);
                }, name: name, defaultValue: defaultValue, value: value, isSearchable: isSearchable && !isSearchInList, isClearable: isClearable, isMulti: isMulti, isError: isError, isDisabled: isDisabled, menuIsOpen: isMenuOpen, isOptionSelected: (option) => isSelected(option), components: {
                    Control: (props) => {
                        return (React.createElement(components.Control, Object.assign({}, props, { innerProps: {
                                onMouseDown: (e) => {
                                    props.innerProps.onMouseDown &&
                                        props.innerProps.onMouseDown(e);
                                    if (e.button === 0 && !isDisabled) {
                                        controlRef.current = e.target;
                                        setIsMenuOpen((val) => !val);
                                    }
                                },
                            } })));
                    },
                    Menu: (_a) => {
                        var { children } = _a, otherProps = __rest(_a, ["children"]);
                        return (React.createElement(FTLDropdownMenu, { ref: popperRef, open: true, containerRef: containerRef, placement: popperPlacement, menuWidth: menuWidth },
                            isSearchable && isSearchInList && (React.createElement(FTLTextField, { variant: "standard", autoCorrect: "off", autoComplete: "off", autoFocus: true, spellCheck: "false", onMouseDown: (e) => {
                                    e.stopPropagation();
                                }, onTouchStart: (e) => {
                                    e.stopPropagation();
                                }, placeholder: searchPlaceholder, style: { marginBottom: 8 }, value: otherProps.selectProps.inputValue, onChange: (e) => {
                                    if (otherProps.selectProps.onInputChange) {
                                        otherProps.selectProps.onInputChange(e.currentTarget.value, {
                                            action: "input-change",
                                        });
                                    }
                                }, fullWidth: true, InputProps: {
                                    style: { paddingLeft: 4 },
                                    endAdornment: (React.createElement(InputAdornment, { position: "end" }, otherProps.selectProps.inputValue ? (React.createElement(FTLIconButton, { onClick: () => {
                                            if (otherProps.selectProps.onInputChange) {
                                                otherProps.selectProps.onInputChange("", {
                                                    action: "input-change",
                                                });
                                            }
                                        }, tabIndex: -1, disabled: isDisabled },
                                        React.createElement(ClearIcon, null))) : (React.createElement(FTLIconButton, { tabIndex: -1, disabled: isDisabled },
                                        React.createElement(SearchIcon, null))))),
                                } })),
                            children));
                    },
                    MenuList: (_a) => {
                        var { children } = _a, props = __rest(_a, ["children"]);
                        const classes = useStylesMenu({ withCheckboxes });
                        return (React.createElement(InfiniteLoader, { itemSize: itemSize, queryValue: props.selectProps.inputValue, type: "async", 
                            // @ts-ignore
                            items: React.Children.map(children, 
                            //@ts-ignore
                            (item) => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.data; }), loadItems: (startIndex) => __awaiter(this, void 0, void 0, function* () {
                                var _b;
                                try {
                                    const response = yield loadData.promiseFn({
                                        query: (_b = props.selectProps.inputValue) !== null && _b !== void 0 ? _b : "",
                                        offset: startIndex,
                                        sortDirection: "ASC",
                                        sortName: "name",
                                    });
                                    return {
                                        items: response.data.result.items,
                                        count: response.data.result.count,
                                    };
                                }
                                catch (e) {
                                    return {
                                        items: [],
                                        count: 0,
                                    };
                                }
                            }), normalizeScheme: loadData.normalizeScheme, records: records, itemRenderer: ({ index, style, data }) => {
                                return (data === null || data === void 0 ? void 0 : data.type) === "loading" ? (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", style: style }, data.component)) : (React.createElement(Box, { display: "flex", justifyContent: "space-between", onMouseDown: (e) => e.button === 0 &&
                                        data.value &&
                                        props.selectOption(data), onTouchStart: (e) => data.value && props.selectOption(data), className: classes.option, style: style }, data && (React.createElement(React.Fragment, null,
                                    withCheckboxes ? (React.createElement(FTLCheckbox, { label: data.label, checked: isSelected(data) })) : (React.createElement("span", null, data.label)),
                                    data.meta && (React.createElement(FTLTypography, { color: "tertiary", variant: "listItemText" }, data.meta))))));
                            } }));
                    },
                    IndicatorSeparator: () => null,
                    ValueContainer: (props) => {
                        if (isSearchable && isSearchInList)
                            return React.createElement(CustomValueContainer, Object.assign({}, props));
                        else
                            return React.createElement(components.ValueContainer, Object.assign({}, props));
                    },
                    DropdownIndicator: (props) => {
                        return (React.createElement(components.DropdownIndicator, Object.assign({}, props, { innerProps: {
                                onClick: (e) => {
                                    e.button === 0 && !isDisabled && setIsMenuOpen(true);
                                },
                            } }),
                            React.createElement(ChevronIcon, null)));
                    },
                    LoadingIndicator: () => showLoader ? React.createElement(FTLDots, { color: "tertiary" }) : React.createElement(React.Fragment, null),
                    ClearIndicator: (props) => {
                        return (React.createElement(components.ClearIndicator, Object.assign({}, props),
                            React.createElement(ClearIcon, null)));
                    },
                } }, otherProps)))));
}
const useStylesMenu = makeStyles((theme) => ({
    option: ({ withCheckboxes }) => (Object.assign(Object.assign({}, typography.unsupportedSemanticTags.listItemText), { padding: withCheckboxes ? "0 12px" : "6px 12px", backgroundColor: "#fff", color: theme.palette.text.primary, boxSizing: "border-box", cursor: "pointer", outline: "none", "&:hover": {
            backgroundColor: "#f5f5f6",
        } })),
}));
//# sourceMappingURL=FTLSelectAsync.js.map